module.exports = __webpack_public_path__ + "img/form_todolist.d9d122b7.svg";